module.exports = __webpack_public_path__ + "static/media/4.a26a46a8.jpeg";